import { CSSProperties, useRef, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import useOutsideClick from "../../../hooks/useOutsideClick";

// Same props, markup and styling as FindDropdown, but it stays open until an item is picked or the user
// clicks outside it, like the burger menu.
//
// How it differs from FindDropdown:
// - FindDropdown closes on mouse leave. That also fires when the #loader overlay appears under the cursor
//   during a background refresh (e.g. the 60s mailbox refresh in TopRow), so it keeps closing on a busy mailbox.
//   This one closes on an outside mousedown (useOutsideClick), which the overlay does not trigger.
// - FindDropdown resets its filtered list whenever its children change, undoing the search on every refresh.
//   This one keeps the search text in state and filters on every render, so a refresh keeps the search.
export type findDropdownPersistProps = {
    id: number;
    label: string;
    children: Array<any>;
    styles?: CSSProperties;
};
const FindDropdownPersist = (props: findDropdownPersistProps) => {
    const buttonRef = useRef<HTMLDivElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [placeholder, RemovePlaceholder] = useState("Search");

    const closeDropdown = () => {
        setDropdownOpen(false);
        setSearchText("");
    };
    useOutsideClick(buttonRef, () => dropdownOpen && closeDropdown());

    // closes the dropdown once a selection has been clicked
    const items = props.children.map((x: any) => ({ ...x, props: { ...x.props, onClick: closeDropdown } }));
    const visibleItems =
        searchText.length > 2
            ? items.filter((mb: React.ReactElement) => {
                  const text = mb?.props?.children?.props?.children;
                  return typeof text === "string" && text.toLowerCase().includes(searchText.toLowerCase());
              })
            : items;

    return (
        <div
            className={"g-find-dropdown" + (dropdownOpen ? "-selected" : "")}
            key={props.id}
            ref={buttonRef}
            title={props.label}
            style={props.styles}
        >
            <div
                className="findDropDownWrapper"
                tabIndex={0}
                onClick={() => (dropdownOpen ? closeDropdown() : setDropdownOpen(true))}
            >
                <div className="Col1"> {props.label}</div>
                <div className="Col2">
                    <BsChevronDown style={{ fontSize: "10px", marginLeft: "10px", float: "right" }}> </BsChevronDown>
                </div>
            </div>
            {dropdownOpen && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: "1000",
                        backgroundColor: "white",
                        height: "40px",
                        width: "205px",
                    }}
                >
                    {" "}
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{
                            borderColor: "#888",
                            width: "200px",
                            marginLeft: "2px",
                            marginRight: "5px",
                            fontSize: "13px",
                        }}
                        autoComplete="off"
                        aria-autocomplete="none"
                        list="autocompleteOff"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        placeholder={placeholder}
                        onFocus={e => RemovePlaceholder("")}
                        onMouseOut={e => RemovePlaceholder("Search")}
                    ></input>
                </div>
            )}
            <ul>{visibleItems}</ul>
        </div>
    );
};

export default FindDropdownPersist;
